import React, { Component } from "react";
import { FontAwesomeIcon }            from '@fortawesome/react-fontawesome'
import { Button, Modal, FormControl } from "react-bootstrap";
import { invokeSetCreateReminder }    from "../../utils/AwsInvoke";
import { Colors }                     from "../../utils/Colors";
import LoaderButton                   from "../../components/LoaderButton";
import "../../css/modal/ModalCreateFolder.css";
import "../../css/modal/ModalBasics.css";

export default class ModalAddReminder extends Component {

    constructor(props) {
        super(props);

        this.state = {
            showModalSimple: false,
            title: "",
            error: ""
        };
    }

    componentWillUnmount() {
        // Reset Input Values
        this.setState({
            title: "",
            error: ""
        });
    }

    handleTitleChange (event) {
        this.setState({
            title: event.target.value
        });
    }

    handleNotesChange = (event) => {
        this.setState({ notes: event.target.value});
    }

    handleSubmit = async event => {
        var title       = this.state.title;
        var assigned_to = "K dog"
        var date        = "2016-06-23";
        var time        = "2015-09-01T16:34:02";
        var notes       = this.state.notes;
        console.log("title: " + title);
        console.log("notes: " + notes);

        if(title != "" ) {
            const results = await invokeSetCreateReminder(title, assigned_to, date, time, notes);

            if(results.status != null) {
                this.props.onHide(); // Close Modal //
            }
        } else {
            this.setState({
                error: "You must enter a folder name."
            })
        }
    }

    handleKeyPress = (target) => {
        // Allow user to hit "Enter" when using Search box //
         if(target.charCode === 13) {
             this.props.onHide();
             this.handleSubmit();
        }
    }

    cancel () {
        this.props.onHide();
    }

    render() {
        var notes = this.props.notes;
        var error = this.state.error;
        return (
            <Modal
                show={this.props.show}
                onHide={this.props.onHide}
              >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title" className="fontSize26px">
                        <FontAwesomeIcon icon="bell"
                                         className="modalBasicsTitleIcon"
                                         style={{ position:"relative", color: Colors.primary_color}}/>
                        <span className="modalBasicsTitle">
                             Add Reminder
                        </span>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <span className="modalBasicsBody">
                          Send yourself or co-worker a reminder.
                          <br/><br/>
                          <div>
                              <div className="modalFormLabelBody">Title</div>
                              <FormControl
                                  onChange     = {this.handleTitleChange.bind(this)}
                                  defaultValue = {""}
                                  className    = "input-lg formModalExerciseField"
                                  type         = "text"
                                  onKeyPress   = {this.handleKeyPress}
                              />
                          </div>
                          <br/>
                          <div>
                              <div className="modalFormLabelBody">Deadline</div>
                              <FormControl
                                  onChange     = {this.handleTitleChange.bind(this)}
                                  defaultValue = {""}
                                  className    = "input-lg formModalExerciseField"
                                  type         = "text"
                                  onKeyPress   = {this.handleKeyPress}
                              />
                          </div>
                          <br/>

                          { /*}<div>
                              <div className="modalFormLabelBody">Assign To</div>
                              <FormControl
                                  onChange     = {this.handleTitleChange.bind(this)}
                                  defaultValue = {""}
                                  className    = "input-lg formModalExerciseField"
                                  type         = "text"
                                  onKeyPress   = {this.handleKeyPress}
                              />
                              </div>
                              <br/> */ }
                          <div>
                              <div className="modalFormLabelBody">Notes</div>
                              <textarea placeholder  = {""}
                                        style        = {{paddingLeft: "15px",paddingTop:"10px", height: 120, width:"100%", fontSize:"20px", border: "2px solid #ccc"}}
                                        value        = {this.state.notes}
                                        onChange     = {this.handleNotesChange}
                                     />
                          </div>
                          <span style={{paddingTop:15, fontSize: 16, color: "red"}}>{error}</span>
                    </span>
                </Modal.Body>
                <Modal.Footer>
                    <span onClick = { () => this.cancel()} >
                        <LoaderButton
                          height    = {38}
                          width     = {150}
                          btncolor  = { Colors.cancel_button_bg }
                          type      = "button"
                          text      = "Cancel"
                          className="modalBasicsBtnClose"
                        />
                    </span>
                    <span className="modalBasicsFooterXPosSpacer"/>
                    <span onClick = { () => this.handleSubmit()}>
                        <LoaderButton
                            //disabled={!this.validateForm()}
                            isLoading={this.state.isLoading}
                            height    = {38}
                            width     = {150}
                            btncolor  = { Colors.ok_button_bg }
                            text    = "Submit"
                            type    = "submit"
                            loadingText="Saving …"
                        />
                   </span>
                </Modal.Footer>
              </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/modal/ModalAddReminder.js